import { ApplicationConfirmationScreen } from "@/interactors/ApplicationConfirmationScreen";

export default function Confirmation() {
  return <ApplicationConfirmationScreen />;
}
